import {FormatterBasic} from "./Core/FormatterBasic";

export class MultipleSelectionFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');
    }

}